export const GET_ASSESSMENT_GROUPS = 'GET_ASSESSMENT_GROUPS'
export const GET_ASSESSMENT_GROUP = 'GET_ASSESSMENT_GROUP'
export const ADD_ASSESSMENT_GROUP = 'ADD_ASSESSMENT_GROUP'
export const UPDATE_ASSESSMENT_GROUP = 'UPDATE_ASSESSMENT_GROUP'
export const DELETE_ASSESSMENT_GROUP = 'DELETE_ASSESSMENT_GROUP'
